import { BaseSignalLine } from "./base-signal-line";

export class NullableSignalLine extends BaseSignalLine {
  constructor(id, settings, parent, canvas) {
    super(id, settings, parent, canvas);
  }

  draw(gl, program) {
    if (this.signalBuffer.graphicIndex < 0) {
      return;
    }
    const parentSettings = this.settings.parent.ref.settings;
    gl.viewport(
      parentSettings.absoluteLocation.x,
      parentSettings.absoluteLocation.y,
      parentSettings.clientSize.width,
      parentSettings.clientSize.height
    );
    program.setUnforms(this.uniforms);

    gl.enableVertexAttribArray(program.attribs.a_position);

    gl.bindBuffer(gl.ARRAY_BUFFER, this.glBuffer);
    gl.vertexAttribPointer(program.attribs.a_position, 2, gl.FLOAT, false, 0, 0);

    if (this.signalBuffer.isColumnMode) {
      for (let sectorIndex = 0; sectorIndex < this.signalBuffer.notNullSectors.length; sectorIndex++) {
        const sector = this.signalBuffer.notNullSectors[sectorIndex];
        gl.drawArrays(gl.LINES, sector.begin * 2, (sector.end - sector.begin + 1) * 2);
      }
    } else {
      for (let sectorIndex = 0; sectorIndex < this.signalBuffer.notNullSectors.length; sectorIndex++) {
        const sector = this.signalBuffer.notNullSectors[sectorIndex];
        gl.drawArrays(gl.LINE_STRIP, sector.begin * 2, (sector.end - sector.begin + 1) * 2);
      }
    }
  }
}
